import { render } from "./HistoriaClinicaAdulto.vue?vue&type=template&id=9b883a36&scoped=true"
import script from "./HistoriaClinicaAdulto.vue?vue&type=script&lang=js"
export * from "./HistoriaClinicaAdulto.vue?vue&type=script&lang=js"

import "./HistoriaClinicaAdulto.vue?vue&type=style&index=0&id=9b883a36&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b883a36"]])

export default __exports__